import { z } from 'zod';

import { MAX_TITLE_LENGTH } from './consts';

export const createEditColumnFormSchema = (titleMaxLengthMessage: string) =>
    z.object({
        color: z.string(),
        title: z.string().trim().max(MAX_TITLE_LENGTH, titleMaxLengthMessage),
    });

export type TEditColumnFormInput = z.input<ReturnType<typeof createEditColumnFormSchema>>;
export type TEditColumnFormState = z.output<ReturnType<typeof createEditColumnFormSchema>>;
